var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "is-clickable is-unselectable py-0 px-0",
      class: `quote-attachment-background-${_vm.$theme.name}`,
    },
    [
      _c(
        "div",
        { staticClass: "columns is-gapless is-multiline is-relative" },
        [
          _c(
            "div",
            {
              staticClass: "button is-primary is-small px-1 m-0",
              class: {
                "is-light": !_vm.isSelectedComputed,
                [`is-light-btn-${_vm.$theme.name}`]: !_vm.isSelectedComputed,
              },
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                "z-index": "1",
              },
              on: {
                click: function ($event) {
                  return _vm.handleIsSelectedChange(!_vm.isSelectedComputed)
                },
              },
            },
            [
              _c("i", {
                staticClass: "mdi mdi-check",
                class: { "has-text-grey-light": !_vm.isSelectedComputed },
              }),
            ]
          ),
          _c(
            "div",
            { staticClass: "column is-full is-clipped" },
            [
              _c(
                "figure",
                {
                  staticClass: "image is-3by4 is-fullwidth is-vcentered",
                  on: { click: _vm.handleAttachmentClick },
                },
                [
                  _c("img", {
                    staticStyle: { "object-fit": "cover" },
                    attrs: { src: _vm.thumbnailUrl },
                  }),
                ]
              ),
              _c("quote-attachment-viewer-modal", {
                attrs: {
                  active: _vm.modalOpen,
                  attachment: _vm.attachment,
                  "quote-id": _vm.quoteId,
                  "quote-attachment-id": _vm.quoteAttachmentId,
                  "quote-attachment-category-id": _vm.quoteAttachmentCategoryId,
                },
                on: {
                  cancel: function ($event) {
                    _vm.modalOpen = false
                  },
                  "updated-image": function ($event) {
                    return _vm.imageUpdated()
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "column is-full is-size-7 is-clipped columns is-multiline",
            },
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass: "columns is-multiline column is-clipped p-0 m-0",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "column is-full p-0 m-0",
                      staticStyle: {
                        overflow: "hidden",
                        "text-overflow": "ellipsis",
                        "font-weight": "bold",
                        "white-space": "nowrap",
                      },
                      attrs: {
                        tooltip: _vm.attachment.filename,
                        title:
                          _vm.attachment.filename + "(" + _vm.pagesCount + ")",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.attachment.filename) +
                          "(" +
                          _vm._s(_vm.pagesCount) +
                          ")"
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "column is-full p-0 m-0" }, [
                    _vm._v(_vm._s(_vm.fileDateTime)),
                  ]),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-narrow p-0 m-0" }, [
      _c("i", { staticClass: "mdi mdi-drag-vertical mdi-24px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }